<template>
  <span class="glow-text" :class="{ 'glow-text--pulse': pulse }">
    <slot />
  </span>
</template>

<script setup lang="ts">
defineProps<{
  pulse?: boolean
}>()
</script>

<style scoped>
.glow-text {
  background: linear-gradient(135deg, var(--primary), #00ffcc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
  filter: drop-shadow(0 0 8px var(--primary-glow)) drop-shadow(0 0 16px rgba(0, 212, 255, 0.15));
}

.glow-text--pulse {
  animation: glow-text-pulse 3s ease-in-out infinite;
}

@keyframes glow-text-pulse {
  0%, 100% {
    filter: drop-shadow(0 0 8px var(--primary-glow)) drop-shadow(0 0 16px rgba(0, 212, 255, 0.15));
  }
  50% {
    filter: drop-shadow(0 0 16px var(--primary-glow)) drop-shadow(0 0 32px rgba(0, 212, 255, 0.25));
  }
}
</style>
